module.exports = __webpack_public_path__ + "img/scheduling.1ea8ce4f.png";